import { clients } from "../actions/types"

const defaultClientsData = {
	data: [],
	isLoading: true,
	hasError: false,
	isDeleting: false,
	isRestoring: false,
	isShowing: false,
	isExporting: false,
	per_page: 15,
	current_page: 1,
	filters: [],
	meta: {
		pagination: {
			total: 0,
			count: 0,
			per_page: 15,
			current_page: 1,
			total_pages: 1,
		}
	}
}

const clientsReducer = (state = defaultClientsData, action) => {
	switch (action.type) {

	case clients.GET_CLIENTS_STARTED:
		return { ...state, isLoading: true }

	case clients.GET_CLIENTS_SUCCESS:
		return { ...state, ...action.payload, isLoading: false }

	case clients.GET_CLIENTS_ERROR:
		return { ...state, isLoading: false }

	case clients.SHOW_CLIENT_STARTED:
		return { ...state, isShowing: true }

	case clients.SHOW_CLIENT_SUCCESS:
		if (!action.payload.id)
			return state
		if (state.data.find(item => (item.id === action.payload.id)))
			return { ...state, data: state.data.map(item => (item.id === action.payload.id ? action.payload : item)), isShowing: false }
		return { ...state, data: [...state.data, action.payload], isShowing: false }

	case clients.SHOW_CLIENT_ERROR:
		return { ...state, isShowing: false, hasError: true }

	case clients.DELETE_CLIENT_STARTED:
		return { ...state, isDeleting: true }

	case clients.DELETE_CLIENT_SUCCESS:
		if (action.payload)
			return { ...state, data: state.data.filter(item => (item.id !== action.payload.id)), isDeleting: false }
		return state

	case clients.DELETE_CLIENT_ERROR:
		return { ...state, isDeleting: true }

	case clients.CREATE_CLIENT_STARTED:
		return { ...state, isSaving: true }

	case clients.CREATE_CLIENT_SUCCESS:
		if (action.payload)
			return {
				...state,
				data: [...state.data, { ...action.payload.data }],
				isSaving: false
			}
		return state

	case clients.CREATE_CLIENT_ERROR:
		return { ...state, isSaving: false, hasError: true }

	default:
		return state
	}
}

export default clientsReducer
